module.exports = __webpack_public_path__ + "img/logo-sender.1437f4a4.svg";